import {generateClient} from 'aws-amplify/api';
import {workflowsApiConfig} from "./config/index.ts";

export const workflowsApiClient = generateClient({
    endpoint: workflowsApiConfig.endpoint,
    region: workflowsApiConfig.region,
    authMode: 'userPool'
});
